import { Injectable, inject } from '@angular/core';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { TableType } from '@app/pages/cmms/types';
import { IActionCenterSuggester, IAiSuggestActions } from '../../interfaces';
import { ClassificationSuggester, FileTaggingSuggester } from './ai-suggestions';
import { FileAiSuggestionService } from '@app/pages/files/services/file-ai-suggestion.service';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { Apollo } from 'apollo-angular';
import { TranslateService } from '@tolgee/ngx';
@Injectable({
	providedIn: 'root',
})
export class AiSuggestionsFactory {
	suggestMap;
	filesService = inject(FilesService);
	fileAiSuggestionService = inject(FileAiSuggestionService);
	apollo = inject(Apollo);
	actionCenterService = inject(ActionCenterService);
	notify = inject(IconSnackBarService);
	translateService = inject(TranslateService);

	deps = {
		[TableType.FILES]: {
			filesService: this.filesService,
			fileAiSuggestionService: this.fileAiSuggestionService,
			apollo: this.apollo,
			actionCenterService: this.actionCenterService,
			notify: this.notify,
			translateService: this.translateService,
		},
	};

	constructor() {
		this.suggestMap = {
			[TableType.FILES]: {
				classificationSuggestions: ClassificationSuggester,
				autoTagging: FileTaggingSuggester,
			},
		};
	}
	createSuggester(
		tableType: TableType,
		targetType: IAiSuggestActions
	): IActionCenterSuggester {
		const deps = this.deps[tableType];
		return new this.suggestMap[tableType][targetType](deps);
	}

	canCreate(tableType: TableType, targetType: IAiSuggestActions): boolean {
		return this.suggestMap[tableType][targetType] !== undefined;
	}
}
